import React, { FC, Dispatch, SetStateAction } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Close } from '@components/icons';
import { OrganizationSwitcher } from './OrganizationSwitcher';
import { OverviewFilterDropdowns } from './OverviewFilterDropdowns';
import { LFDrawer } from '@app/_components/common/LFDrawer';
export const FilterDrawer: FC<{
  setShowFilters: Dispatch<SetStateAction<boolean>>;
}> = observer(({
  setShowFilters
}) => {
  const {
    t
  } = useTranslation();
  return <LFDrawer width="w-full md:w-1/3" onClickOutside={() => setShowFilters(false)}>
      <div>
        <div className={`
            w-full px-6
            lg:px-0
          `}>
          <div onClick={() => setShowFilters(false)}>
            <Close className={`
                absolute top-3 right-4 h-12 w-12 cursor-pointer
                lg:right-16
              `} />
          </div>

          <div className={`
              mx-auto flex w-full flex-col justify-between gap-4 py-6 text-center
              md:flex-row
            `}>
            <div className={`
                mx-auto flex w-full justify-center gap-x-1 text-center text-2xl font-medium
              `}>
              {t('filters')}
            </div>
          </div>
        </div>

        <hr className="mb-5 block h-px w-full border-gray-200 bg-gray-300" />

        <div className={`
            flex w-full flex-col flex-wrap-reverse items-center gap-x-4
            lg:flex-nowrap
            print:hidden
          `}>
          <OrganizationSwitcher />
          <OverviewFilterDropdowns />
        </div>
      </div>
    </LFDrawer>;
});